import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";

  switch (params.trip) {
    case "October-2026":
      dates = "September 29 - October 13, 2026";
      break;
    case "trip":
      dates = "";
      break;
  }
  return (
    <div className={styles.backgroundPictureTurkey}>
      <div className={styles.titleBox}>
        <h1>
          Visit the country that has more biblical sites than any place other
          than Israel.
        </h1>
        <p className={styles.title}>Turkey</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            The boat trip to Patmos and touring the “Seven Churches of
            Revelation” sites will be an experience never to be forgotten.
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
